export default __webpack_public_path__ + "static/media/113.977262ec.png";